import { isWithinInterval, parseISO } from 'date-fns';
import { ISubsidyBanner } from '../../interfaces/Banner.interfaces';

export const BANNER_LIST: ISubsidyBanner[] = [
  {
    id: 'banner_260212',
    showBanner: true,
    startDate: '2026-02-01',
    endDate: '2026-03-03',
    displayIndex: 0,
    targetCategories: ['전체', '시설', '과수·원예', '유통·판매'],
    categoryLabel: '저온저장고',
    title: '저온저장고 업체 선정, 고민이세요?',
    bgColor: '#37C77E',
    icon: 'Snowflake',
    showDetailBtn: true,
    detailBtnText: '1위 업체 견적 받기',
    linkUrl: '/info/55057f51-7720-4ac6-b779-b56a0eb5e5f9',
  },
];

export const getActiveBanners = (categories: string[]) => {
  const now = new Date();
  return BANNER_LIST.filter((banner) => {
    const isVisible =
      banner.showBanner &&
      isWithinInterval(now, {
        start: parseISO(banner.startDate),
        end: parseISO(banner.endDate),
      });

    // logic:
    // 1. If 'all' is included, show in all category tabs.
    // 2. If any of the selected categories matches one of entries in targetCategories, show it.
    const isCategoryMatch =
      banner.targetCategories.includes('all') || categories.some((cat) => banner.targetCategories.includes(cat));

    return isVisible && isCategoryMatch;
  });
};
